<template>
  <div class="h-full flex-grow flex-shrink md:flex">
    <div class="w-full h-full">
      <div class="h-full w-full flex flex-col overflow-hidden">
        <div class="h-100 flex-grow flex-shrink">
          <o-tabs
            ref="tabs"
            nav-class="h-10 w-full max-w-5xl mx-auto"
            container-class="py-5 px-6 flex-grow flex-shrink h-100 border-t bg-gray-50 dark:bg-gray-900 dark:border-gray-800"
            scroll
          >
            <div class="mx-auto w-full max-w-5xl">
              <o-tab :name="$t('components.customer.profile.tabs.profile')" icon="customer">
                <detail :customer="customer" />
              </o-tab>
              <o-tab :name="$t('general.appointments')" icon="reservation" initial>
                <reservations :customer="customer" />
              </o-tab>
              <o-tab :name="$t('general.sales')" icon="sale">
                <sales :customer="customer" />
              </o-tab>
              <o-tab :name="$t('general.notes')" icon="notes">
                <notes :customer="customer" />
              </o-tab>
              <o-tab v-if="$features.get('forms')" :name="$t('general.forms')" icon="forms" :alert="customer.incompleteFormCount">
                <customer-forms :customer="customer" />
              </o-tab>
              <o-tab :name="$t('general.uploads')" icon="upload" :alert="customer.uploadCount">
                <uploads :customer="customer" />
              </o-tab>
              <o-tab v-if="$features.get('passes')" :name="$t('components.customer.profile.tabs.passesCourses')" icon="pass">
                <passes :customer="customer" />
              </o-tab>
              <o-tab :name="$features.get('gift-cards') ? $t('components.customer.profile.tabs.giftCardsCredit') : 'Credit'" icon="giftCard">
                <gift-cards :customer="customer" />
              </o-tab>
              <o-tab :name="$t('components.customer.profile.tabs.creditCards')" icon="creditCard">
                <credit-cards :customer="customer" />
              </o-tab>
              <o-tab :name="$t('general.products')" icon="product">
                <products :customer="customer" />
              </o-tab>
            </div>
          </o-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Detail from '@/components/customer/profile/details.vue'
import Notes from '@/components/customer/profile/notes.vue'
import Products from '@/components/customer/profile/products.vue'
import Reservations from '@/components/customer/profile/reservations.vue'
import Sales from '@/components/customer/profile/sales.vue'
import CustomerForms from '@/components/customer/profile/customerForms.vue'
import Passes from '@/components/customer/profile/passes.vue'
import GiftCards from '@/components/customer/profile/giftCards.vue'
import CreditCards from '@/components/customer/profile/creditCards.vue'
import Uploads from '@/components/customer/profile/uploads.vue'

import {
  OTabs,
  OTab,
} from '@/components/elements'

interface Props {
  customer: Record<string, any>
}

defineProps<Props>()

const tabs = ref<any>()

const selectTab = (tab: string) => {
  tabs.value?.selectTab('#' + tab)
}

defineExpose({ selectTab })
</script>
